import React, { useState, useEffect } from 'react'
import { useTrans } from 'hooks'
import { useMeQuery } from 'gql/graphql'
import { setupMaster } from 'cluster'
import { MyAccountEditCard, MyAccountSection } from 'components/molecules'
import {
  MyAccountPage,
  MyAccountFormNome,
  MyAccountFormPassword,
  MyAccountFormNewsletter,
} from 'components/organisms'
import { Profile, Mail, Lock, Edit } from 'components/atoms/Icons'
import { FormCheckbox, FormField } from 'components/atoms'

interface Props {
  pagina?: any
}

const MyAccountHomeTemplate = (props: Props) => {
  const { pagina = null } = props
  
  const t = useTrans()
  const [formNomeOpen, setFormNomeOpen] = useState(false)
  const [formPasswordOpen, setFormPasswordOpen] = useState(false)
  const [formNewsletterOpen, setFormNewsletterOpen] = useState(false)
  const [utente, setUtente] = useState({
    nome: '',
    cognome: '',
    email: '',
    privacyCommerciale: false,
  })
  const { data: dataUtente } = useMeQuery()

  useEffect(() => {
    if (dataUtente?.me) {
      setUtente({
        nome: dataUtente.me.nome,
        cognome: dataUtente.me.cognome,
        email: dataUtente.me.email,
        privacyCommerciale: dataUtente.me.privacyCommerciale,
      })
    }
  }, [dataUtente])

  return (
    <MyAccountPage
      pagina={{ titolo: pagina?.titolo, descrizione: pagina?.descrizione, icon: <Profile /> }}
      activeMenuKey="account"
    >
      <MyAccountSection>
        {formNomeOpen ? (
          <MyAccountFormNome onCancel={() => setFormNomeOpen(false)} utente={utente} />
        ) : (
          <MyAccountEditCard
            icon={<Profile />}
            fields={[
              { label: t('Nome'), value: utente.nome },
              { label: t('Cognome'), value: utente.cognome },
            ]}
            fieldsMobile={[
              { label: t('Nome e cognome'), value: `${utente.nome} ${utente.cognome}` },
            ]}
            editLabel={t('Modifica dati')}
            editIcon={<Edit />}
            onEdit={() => setFormNomeOpen(true)}
          />
        )}
      </MyAccountSection>

      <MyAccountSection>
        <MyAccountEditCard
          icon={<Mail />}
          fields={[{ label: t('Email'), value: utente.email }]}
          editLabel={t('Modifica email')}
          editIcon={<Edit />}
          className="myaccount-home-template__email-edit-card"
          disabled
        />
      </MyAccountSection>

      <MyAccountSection>
        {formPasswordOpen ? (
          <MyAccountFormPassword onCancel={() => setFormPasswordOpen(false)} />
        ) : (
          <MyAccountEditCard
            icon={<Lock />}
            fields={[{ label: t('Password'), value: '°°°°°°°' }]}
            editLabel={t('Modifica password')}
            editIcon={<Edit />}
            onEdit={() => setFormPasswordOpen(true)}
          />
        )}
      </MyAccountSection>

      <MyAccountSection>
        {formNewsletterOpen ? (
          <MyAccountFormNewsletter onCancel={() => setFormNewsletterOpen(false)} utente={utente} />
        ) : (
          <MyAccountEditCard
            fields={[
              {
                label: '',
                value: (
                  <FormField
                    label={t('Iscrizione alla newsletter')}
                    className="myaccount-home-template__newsletter-formfield"
                  >
                    <FormCheckbox
                      id="myaccount-form-newsletter__newsletter"
                      label={t(
                        'Acconsento al trattamento dei miei dati personali per ricevere offerte e comunicazioni commerciali da parte di Vinicum.'
                      )}
                      checked={utente.privacyCommerciale}
                      disabled
                    />
                  </FormField>
                ),
              },
            ]}
            editLabel={t('Modifica')}
            onEdit={() => setFormNewsletterOpen(true)}
            className="myaccount-home-template__newsletter-edit-card"
          />
        )}
      </MyAccountSection>
    </MyAccountPage>
  )
}

export default MyAccountHomeTemplate
